import { RECAPTCHA_URL } from '..';
export const loadRecaptchaScript = (callback) => {
    const existingScript = document.getElementById('recaptcha-enterprise-script');
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = RECAPTCHA_URL;
        script.id = 'recaptcha-enterprise-script';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            if (callback)
                callback();
        };
        document.body.appendChild(script);
    }
    else if (callback)
        callback();
};
export const removeRecaptcha = () => {
    var _a;
    const recaptchaBadge = document.querySelector('.grecaptcha-badge');
    const recaptchaScript = document.getElementById('recaptcha-enterprise-script');
    recaptchaScript === null || recaptchaScript === void 0 ? void 0 : recaptchaScript.remove();
    (_a = recaptchaBadge === null || recaptchaBadge === void 0 ? void 0 : recaptchaBadge.parentElement) === null || _a === void 0 ? void 0 : _a.remove();
};
